const SkodaSecondDataInfo = () => {
    return (
        <div className="form-info-container">
            <div className="form-info">
                {/*<p>* Zaakceptuj pliki cookie w lewym dolnym rogu ekranu, aby móc obejrzeć transmisję. Zmiany w ustawieniach plików cookie możesz wprowadzić w każdej chwili. </p>*/}
                <p>
                    Pozostawienie przez Ciebie danych i wysłanie formularza oznacza Twoją zgodę dla Volkswagen Group Polska sp. z o.o. na skontaktowanie się z Tobą w celu przesłania Tobie przypomnienia o prezentacji marki Skoda na podany nr telefonu. Podanie Twoich danych jest dobrowolne, lecz niezbędne do obsługi Twojego zapytania.
                </p>
                <b>Jak przetwarzamy Twoje dane?</b>
                <p>
                    Administratorem danych jest Volkswagen Group Polska Sp. z o.o. z siedzibą w Poznaniu (61-037), ul. Krańcowa 44 wpisana do Rejestru Przedsiębiorców prowadzonego przez Sąd Rejonowy w Poznaniu - Nowe Miasto i Wilda, VIII Wydział Gospodarczy pod numerem KRS 0000327143, NIP 782-24-63-563, REGON 301062169 (VGP).
                </p>
                <p>
                    Więcej informacji dotyczących przetwarzania danych poniżej.
                </p>
                <p>
                    <strong>MOŻESZ UDZIELIĆ TAKŻE DODATKOWYCH ZGÓD CELEM MARKETINGU PRZYSZŁEGO</strong> <br/>(ZGODY SĄ
                    OPCJONALNE I DOBROWOLNE, A ICH UDZIELENIE LUB ODMOWA SĄ NIEZALEŻNE OD OBSŁUGI TWOJEGO ZAPYTANIA)
                </p>
            </div>
        </div>
    );
}

export default SkodaSecondDataInfo;
